<template>
  <v-container fluid grid-list-lg>
    <Create :createDialog="createDialog" @close="createDialog = false" @submit="getList"></Create>
    <Edit :editDialog="editDialog" @close="editDialog = false" @submit="getList" :editTerm="selectedTerm"></Edit>
    <v-card :loading="loading" outlined>
      <ListTitle :showBackButton="true" :access="checkRightStatus(37)" title="Term" @add="add" />

      <v-card-title>
        <v-flex xs12 sm4>
          <v-text-field v-model="search" outlined prepend-inner-icon="search" rounded dense label="Search" single-line
            hide-details clearable></v-text-field>
        </v-flex>
      </v-card-title>
      <v-data-table :headers="headers" :items="terms" :search="search" :loading="loading" :sort-by="sortBy"
        :page.sync="page" :items-per-page="itemsPerPage">
        <template v-slot:item="{ item }">
          <tr class="pointer">
            <td class="text-left">{{ item.name }}</td>
            <td class="text-left">
              <div v-if="item.Year">{{ item.Year.name }}</div>
              <div v-else>N/A</div>
              <div v-if="item.Year && item.Year.Class">{{ item.Year.Class.name }}</div>
            </td>
            <td class="text-left">{{ item.createdAt | moment("LL") }}</td>

            
            <td class="justify-end align-center text-right">
              <v-menu bottom left offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" icon>
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>
                <v-list class="menu-button">
                  <v-list-item v-if="checkRightStatus(39)" @click="editTerm(item)">
                    <v-list-item-title>Edit</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="checkRightStatus(40)" @click="deleteTerm(item)">
                    <v-list-item-title>Delete</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">Your search for "{{ search }}" found no
          results.</v-alert>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import termService from "../service";
import { mapGetters } from "vuex";

const Create = () => import("./Create");
const Edit = () => import("./Edit");
export default {
  name: "term-list",
  data() {
    return {
      createDialog: false,
      editDialog: false,
      selectedTerm: null,
      headers: [
        {
          text: "Title",
          align: "left",
          value: "name",
          sortable: true,
        },

        {
          text: "Year",
          align: "left",
          value: "year",
          sortable: true,
        },
        {
          text: 'Created At',
          align: "left",
          value: "createdAt",
          sortable: true,
        },

        {
          text: "",
          value: "action",
          sortable: false,
        },
      ],
      terms: [],
      search: null,
      loading: true,
      page: 1,
      sortBy: "createdAt",
      pageCount: 0,
      itemsPerPage: 10,
    };
  },
  created() {
    this.getList();
    document.title = "taleem - Term List";
  },
  components: {
    Create,
    Edit,
  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
  },
  methods: {
    add() {
      this.createDialog = !this.createDialog;
    },
    getList() {
      this.loading = true;
      this.editDialog = false
      this.createDialog = false
      return termService.getAll().then((response) => {
        console.log('response', response)
        this.loading = false;
        this.terms = response.data;
        return response;
      });
    },
    editTerm(term) {
      this.selectedTerm = term;
      this.editDialog = !this.editDialog;
    },
    deleteTerm(term) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          termService.delete(term.id).then((response) => {
            if (response.data) {
              this.$swal("Deleted!", "Term has been deleted.", "success");
              this.getList();
            }
          });
        }
      });
    },
  },
};
</script>
